import { PagePlaceholder } from "../components/PagePlaceholder";

export function FunnelPage() {
	return (
		<PagePlaceholder
			title="Funnel"
			subtitle="Where agents drop off between awareness and export."
			endpoint="/v1/insights/manufacturer/funnel"
			rails={[
				{
					heading: "Pinned → Subscribed → Viewed → Configurator Opened → Committed → Placed → Scene Saved → Scene Exported",
					body: "8-stage funnel. Server-side 'biggest drop' annotation as an advisory hint.",
				},
			]}
			callout={[
				"In v0 we ship a thin funnel — only stages 1, 2, 5, 6, 7, 8 light up from server-derived events.",
				"Stages 3 (viewed) and 4 (configurator_opened) need the client SDK; landing in v1.1.",
			]}
		/>
	);
}
